import { render, staticRenderFns } from "./webHooks.vue?vue&type=template&id=e063a20e&scoped=true"
import script from "./webHooks.vue?vue&type=script&lang=js"
export * from "./webHooks.vue?vue&type=script&lang=js"
import style0 from "./webHooks.vue?vue&type=style&index=0&id=e063a20e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e063a20e",
  null
  
)

export default component.exports